import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import $4stjr$intlStringsmodulejs from "./intlStrings.module.js";
import { announce as $4stjr$announce } from "@react-aria/live-announcer";
import { useEffectEvent as $4stjr$useEffectEvent, useUpdateEffect as $4stjr$useUpdateEffect } from "@react-aria/utils";
import { useLocalizedStringFormatter as $4stjr$useLocalizedStringFormatter } from "@react-aria/i18n";
import { useRef as $4stjr$useRef } from "react";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */


function $92599c3fd427b763$export$137e594ef3218a10(props, state) {
  var _props$getRowText = props.getRowText,
      getRowText = _props$getRowText === void 0 ? function (key) {
    var _state_collection_getTextValue, _state_collection, _state_collection_getItem;

    var _state_collection_getTextValue1;

    return (_state_collection_getTextValue1 = (_state_collection_getTextValue = (_state_collection = state.collection).getTextValue) === null || _state_collection_getTextValue === void 0 ? void 0 : _state_collection_getTextValue.call(_state_collection, key)) !== null && _state_collection_getTextValue1 !== void 0 ? _state_collection_getTextValue1 : (_state_collection_getItem = state.collection.getItem(key)) === null || _state_collection_getItem === void 0 ? void 0 : _state_collection_getItem.textValue;
  } : _props$getRowText;
  var stringFormatter = (0, $4stjr$useLocalizedStringFormatter)((0, $parcel$interopDefault($4stjr$intlStringsmodulejs)), '@react-aria/grid'); // Many screen readers do not announce when items in a grid are selected/deselected.
  // We do this using an ARIA live region.

  var selection = state.selectionManager.rawSelection;
  var lastSelection = (0, $4stjr$useRef)(selection);
  var announceSelectionChange = (0, $4stjr$useEffectEvent)(function () {
    var _lastSelection_current;

    if (!state.selectionManager.isFocused || selection === lastSelection.current) {
      lastSelection.current = selection;
      return;
    }

    var addedKeys = $92599c3fd427b763$var$diffSelection(selection, lastSelection.current);
    var removedKeys = $92599c3fd427b763$var$diffSelection(lastSelection.current, selection); // If adding or removing a single row from the selection, announce the name of that item.

    var isReplace = state.selectionManager.selectionBehavior === 'replace';
    var messages = [];

    if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
      if (state.collection.getItem(state.selectionManager.selectedKeys.keys().next().value)) {
        var currentSelectionText = getRowText(state.selectionManager.selectedKeys.keys().next().value);
        if (currentSelectionText) messages.push(stringFormatter.format('selectedItem', {
          item: currentSelectionText
        }));
      }
    } else if (addedKeys.size === 1 && removedKeys.size === 0) {
      var addedText = getRowText(addedKeys.keys().next().value);
      if (addedText) messages.push(stringFormatter.format('selectedItem', {
        item: addedText
      }));
    } else if (removedKeys.size === 1 && addedKeys.size === 0) {
      if (state.collection.getItem(removedKeys.keys().next().value)) {
        var removedText = getRowText(removedKeys.keys().next().value);
        if (removedText) messages.push(stringFormatter.format('deselectedItem', {
          item: removedText
        }));
      }
    } // Announce how many items are selected, except when selecting the first item.


    if (state.selectionManager.selectionMode === 'multiple') {
      if (messages.length === 0 || selection === 'all' || selection.size > 1 || lastSelection.current === 'all' || ((_lastSelection_current = lastSelection.current) === null || _lastSelection_current === void 0 ? void 0 : _lastSelection_current.size) > 1) messages.push(selection === 'all' ? stringFormatter.format('selectedAll') : stringFormatter.format('selectedCount', {
        count: selection.size
      }));
    }

    if (messages.length > 0) (0, $4stjr$announce)(messages.join(' '));
    lastSelection.current = selection;
  });
  (0, $4stjr$useUpdateEffect)(function () {
    if (state.selectionManager.isFocused) announceSelectionChange();else {
      // Wait a frame in case the collection is about to become focused (e.g. on mouse down).
      var raf = requestAnimationFrame(announceSelectionChange);
      return function () {
        return cancelAnimationFrame(raf);
      };
    }
  }, [selection, state.selectionManager.isFocused]);
}

function $92599c3fd427b763$var$diffSelection(a, b) {
  var res = new Set();
  if (a === 'all' || b === 'all') return res;

  var _iterator = _createForOfIteratorHelper(a.keys()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (!b.has(key)) res.add(key);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return res;
}

export { $92599c3fd427b763$export$137e594ef3218a10 as useGridSelectionAnnouncement };